// packages/shared-components/src/components/Radio/Radio.tsx

import { RadioProps } from "./types";
import styles from "./Radio.module.css";
import { Iconfont } from "../Iconfont";

export function Radio({
  value,
  checked = false,
  disabled = false,
  label,
  onChange,
  className = "",
  size = "default",
}: RadioProps) {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(value);
    }
  };

  return (
    <label
      className={`${styles.radio} ${
        disabled ? styles.disabled : ""
      } ${checked ? styles.active : ""} ${
        size === "small" ? styles.small : ""
      } ${className}`}
      onClick={handleClick}
    >
      <span className={styles.iconWrapper}>
        <span
          className={`${styles.ring} ${checked ? styles.hidden : ""}`}
          aria-hidden
        />
        <span
          className={`${styles.iconHolder} ${checked ? "" : styles.hidden}`}
          aria-hidden
        >
          <Iconfont icon="check" className={styles.icon} />
        </span>
      </span>
      {label && <span className={styles.label}>{label}</span>}
    </label>
  );
}
